module.exports = __webpack_public_path__ + "img/make-a-wish-logo.728f7e15.png";